import { jsx as _jsx } from "react/jsx-runtime";
import { wgs84 } from "@evergis/sgis/es/Crs";
import { LabelSymbol } from "@evergis/react";
import { LabelFeature } from "@evergis/sgis/es/features/Label";
import { CurrentFeatureCard } from "../Map/components/CurrentFeatureCard";
export const getCurrentFeatureCard = (feature, onClose, isCompetitor) => {
    return new LabelFeature(feature.geometry.coordinates, {
        crs: wgs84,
        symbol: new LabelSymbol({
            component: () => _jsx(CurrentFeatureCard, { feature: feature, onClose: onClose, isCompetitor: isCompetitor }),
            offset: [-180, -400 - (feature.size?.[1] ?? 0) - 2],
        }),
    }).projectTo(wgs84);
};
